import { gql, QueryHookOptions, useLazyQuery } from '@apollo/client';
import { AuthenticationOptions } from '../../dto';

type Results = { generateAuthenticationOptions: AuthenticationOptions };

export const useGenerateAuthenticationOptions = (options?: QueryHookOptions<Results>) => {
  const query = gql`
    query generateAuthenticationOptions {
      generateAuthenticationOptions {
        challenge
      }
    }
  `;

  return useLazyQuery(query, options);
};

export default useGenerateAuthenticationOptions;

